import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ManifestoSection } from './components/ManifestoSection';
import { ProblemsSection } from './components/ProblemsSection';
import { FeaturesSection } from './components/FeaturesSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <div className="bg-obsidian min-h-screen text-bone selection:bg-crimson selection:text-parchment" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ManifestoSection data-id="element-4" />
        <ProblemsSection data-id="element-5" />
        <FeaturesSection data-id="element-6" />
        <PricingSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
      </main>
      <FooterSection data-id="element-9" />
    </div>;
}